// Import styles
import classes from "./TimeExpiredModal.module.scss";

// Import messages
import messages from "./module/messages";

// Import utils
import { Modal } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import OutlinedButton from "../../../ui/OutlinedButton/OutlinedButton";
import { connect } from "react-redux";
import { logout } from "../../../App/module/actions";
import { createStructuredSelector } from "reselect";
import { selectLoginExpired } from "../../../App/module/selectors";

interface ITimeExpiredModalProps {
  loginExpired: boolean;
  logout: Function;
}

const TimeExpiredModal = (props: ITimeExpiredModalProps) => {
  const { loginExpired, logout } = props;
  return (
    <>
      <Modal
        show={loginExpired}
        size="sm"
        centered
        contentClassName={classes.content}
      >
        <Modal.Header className={classes.header}>
          <Modal.Title style={{ fontSize: "1rem" }}>
            <FormattedMessage {...messages.title} />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ fontSize: "0.75rem" }}>
          <FormattedMessage {...messages.description_one} />
          <br />
          <FormattedMessage {...messages.description_two} />
        </Modal.Body>
        <Modal.Footer className={classes.footer}>
          <OutlinedButton onClick={() => logout()} fullColored>
            <FormattedMessage {...messages.CTA_LOGOUT} />
          </OutlinedButton>
        </Modal.Footer>
      </Modal>
    </>
  );
};

const mapStateToProps: any = () =>
  createStructuredSelector({
    loginExpired: selectLoginExpired,
  });

const mapDispatchToProps: any = {
  logout: () => logout(),
};

const withConnect: any = connect(mapStateToProps, mapDispatchToProps);

export default withConnect(TimeExpiredModal);
